export default "__VITE_ASSET__CE3fs8Xe__"